module.exports = __webpack_public_path__ + "assets/img/xsrm.d8923b62.png";